// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1za58","itemTitle":"ClientEmergencyInfo_itemTitle__1KAOq","itemText":"ClientEmergencyInfo_itemText__1fqHh"};